import React from 'react';
import { string } from 'prop-types';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const FilterIcon = ({ viewBox, height, width, fill }) => {
    return (
        <SvgIcon width={width} viewBox={viewBox} height={height} fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.0929 2.57912C1.25675 2.22596 1.61069 2 2.00001 2H22C22.3893 2 22.7433 2.22596 22.9071 2.57912C23.071 2.93229 23.015 3.34845 22.7636 3.64573L15 12.8261V21C15 21.3466 14.8206 21.6684 14.5257 21.8507C14.2309 22.0329 13.8628 22.0494 13.5528 21.8944L9.5528 19.8944C9.21402 19.725 9.00001 19.3788 9.00001 19V12.8261L1.23644 3.64573C0.985046 3.34845 0.929037 2.93229 1.0929 2.57912ZM4.15532 4L10.7636 11.8143C10.9162 11.9948 11 12.2236 11 12.46V18.382L13 19.382V12.46C13 12.2236 13.0838 11.9948 13.2364 11.8143L19.8447 4H4.15532Z"
                fill={fill}
            />
        </SvgIcon>
    );
};

FilterIcon.propTypes = {
    viewBox: string,
    height: string,
    width: string,
    fill: string,
};

FilterIcon.defaultProps = {
    viewBox: '0 0 24 24',
    height: '24',
    width: '24',
    fill: MIGRATED_COLORS.black,
};

export default FilterIcon;
